import React from 'react'
import FilterMultiDate from "./FilterMultiDate"
import PropTypes from 'prop-types'
import SelectSearch from "./../../../shared/components/SelectSearch"
import {Button} from "antd";

ReportCallFeeSearch.propTypes = {
    receptionDateFrom: PropTypes.string,
    receptionDateTo: PropTypes.string,
    onChangeFrom: PropTypes.func,
    onChangeTo: PropTypes.func
}

function ReportCallFeeSearch(props) {
    const {
        tenants,
        shortPhone,
        filters,
        onChangeFilters,
        receptionDateFrom,
        receptionDateTo,
        onChangeFrom,
        onChangeTo,
        fetchListReport
    } = props

    const _fetchListReport = () => {
        fetchListReport()
    }

    const _handleChangeSelect = (name, value) => {
        onChangeFilters(name, value ? value + '' : '')
    }

    return (
        <div className="PageFilters">
            <FilterMultiDate
                receptionDateFrom={receptionDateFrom}
                receptionDateTo={receptionDateTo}
                onChangeFrom={onChangeFrom}
                onChangeTo={onChangeTo}
            />
            <div className="itemFilter">
                <SelectSearch name="tenantId" value={filters.tenantId ? parseInt(filters.tenantId) : null}
                              onChange={_handleChangeSelect} label="Khách hàng:"
                              listSelect={tenants}/>
            </div>
            <div className="itemFilter">
                <SelectSearch name="shortPhone" value={filters.shortPhone ? parseInt(filters.shortPhone) : null}
                              onChange={_handleChangeSelect} label="Số ảo:"
                              listSelect={shortPhone}/>
            </div>
            <div className="itemFilter">
                <Button type="primary" style={{marginTop: "27px"}} onClick={_fetchListReport}>Tìm kiếm</Button>
            </div>
        </div>
    )
}

export default ReportCallFeeSearch
